/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ(value) {
    return true;
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Height': json['Height'] == null ? undefined : json['Height'],
    };
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Height': value['Height'],
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ.js.map